<div id="ki-insert-panel-change-language">
    <input type="checkbox" id="ki-panel-change-language-input">
    <label id="ki-panel-change-language-label" for="ki-panel-change-language-input" class="ki-insert-panel__menu__item">
        <div class="ki-insert-panel__menu__item__icon">
            <span class="translate-icon"></span>
        </div>

        <div class="ki-insert-panel__menu__item__text language-picker-label">
            <p class="label">{{ label }}:</p>
            <img class="country-flag" [src]="getImageSrc(language.icon)" [alt]="language.country"/>
            <p class="language-name">{{ language.label }}</p>
        </div>

        <div class="ki-insert-panel__menu__item__submenu-icon">
            <svg viewBox="0 0 16.933333 16.933334" height="64" width="64">
                <g transform="translate(0,-280.06665)">
                    <path id="path1074" transform="matrix(0.26458333,0,0,0.26458333,0,280.06665)" d="M 0 32 L 32 64 L 64 32 L 56 32 L 32 56 L 8 32 L 0 32 z" style="fill-opacity:1;stroke:none;"></path>
                </g>
            </svg>
        </div>
    </label>
    <div class="ki-insert-panel__menu__item__submenu">
        <div class="ki-insert-panel__menu__item__submenu__separator"></div>
        <div class="ki-insert-panel__menu__item__submenu-items">
            @for (item of languages; track item) {
                <div class="ki-insert-panel__menu__item ki-insert-panel__menu__item__submenu__item" (click)="onClick(item)">
                    <div class="ki-insert-panel__menu__item__icon">
                        <img class="country-flag" [src]="getImageSrc(item.icon)" [alt]="item.country"/>
                    </div>
                    <span>{{item.label}}</span>
                    <p class="language-symbol-ki">[{{ item.symbol }}]</p>
                </div>
            }
        </div>
    </div>
</div>